<template>
	<div class="card card-accent-dark mb-3">
		<div class="card-header px-3 py-2">
			<i class="fab fa-wikipedia-w fa-lg mr-2"></i>
			{{ __('translations.title.wikidata_tags') }}
			<div class="i-button float-right" @click="showWikidataSearch">
				<i class="fas fa-plus fa-lg"></i>
			</div>
		</div>
		<div class="card-body wikidata-list p-3">
			<div v-if="image.tags.length == 0" class="text-muted">
				{{ __('translations.message.no_wikidata_tags') }}
			</div>
			<ul v-else class="list-group list-group-flush">
				<li v-for="tag in image.tags" :key="tag.id" class="list-group-item d-flex justify-content-between align-items-center px-0 py-2">
					<a :href="wikidataUrl + tag.wikidata_id" target="_blank" class="list-group-item-action">
						<p class="mb-0"><b>{{tag.wikidata_label}} ({{tag.wikidata_id}})</b></p>
						<p class="text-muted mb-0">{{tag.wikidata_desc}}</p>
					</a>
					<div @click="deleteTag(tag)" class="i-button pl-2 py-2">
						<i class="far fa-trash-alt"></i>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import Util from '../mixins/Util'

export default {
	name: 'WikdiataTags',
	mixins: [Util],
	props: ['image'],
	methods: {
		showWikidataSearch() {
			this.$parent.wikidataSearchFlag = true;
		},
		deleteTag(tag) {
			this.$parent.onDeselectedTag(tag);
		}
	}
}
</script>